import { render } from "./LeavesFooter.vue?vue&type=template&id=368c8122&scoped=true"
import script from "./LeavesFooter.vue?vue&type=script&lang=js"
export * from "./LeavesFooter.vue?vue&type=script&lang=js"

import "./LeavesFooter.vue?vue&type=style&index=0&id=368c8122&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368c8122"]])

export default __exports__